import {
  getTaxDocument as publicGetTaxDocument,
  listTaxDocuments as publicListTaxDocuments,
  generateFileDownloadInfo as publicGenerateFileDownloadInfo,
} from './payments-tax-documents-v1-tax-document-tax-documents.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getTaxDocument: MaybeContext<
  BuildRESTFunction<typeof publicGetTaxDocument> & typeof publicGetTaxDocument
> = /*#__PURE__*/ createRESTModule(publicGetTaxDocument);
export const listTaxDocuments: MaybeContext<
  BuildRESTFunction<typeof publicListTaxDocuments> &
    typeof publicListTaxDocuments
> = /*#__PURE__*/ createRESTModule(publicListTaxDocuments);
export const generateFileDownloadInfo: MaybeContext<
  BuildRESTFunction<typeof publicGenerateFileDownloadInfo> &
    typeof publicGenerateFileDownloadInfo
> = /*#__PURE__*/ createRESTModule(publicGenerateFileDownloadInfo);

export {
  TaxDocumentType,
  SourceType,
  WebhookIdentityType,
} from './payments-tax-documents-v1-tax-document-tax-documents.universal.js';
export {
  TaxDocument,
  TaxPeriod,
  TaxPeriodOptionsOneOf,
  YearPeriod,
  GetTaxDocumentFileHistoryRequest,
  GetTaxDocumentFileHistoryResponse,
  TaxDocumentFileHistory,
  TaxDocumentFileHistoryRecord,
  GenerateHistoryFileDownloadInfoRequest,
  GenerateHistoryFileDownloadInfoResponse,
  UpdateTaxDocumentRequest,
  UpdateTaxDocumentResponse,
  RefreshTaxDocumentFileRequest,
  RefreshTaxDocumentFileResponse,
  GenerateFileUploadTargetRequest,
  GenerateFileUploadTargetResponse,
  FileUploadTarget,
  ConfirmFileUploadedRequest,
  ConfirmFileUploadedResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetTaxDocumentRequest,
  GetTaxDocumentResponse,
  ListTaxDocumentsRequest,
  CursorPaging,
  ListTaxDocumentsResponse,
  PagingMetadataV2,
  Cursors,
  GenerateFileDownloadInfoRequest,
  GenerateFileDownloadInfoResponse,
  ListTaxDocumentsOptions,
} from './payments-tax-documents-v1-tax-document-tax-documents.universal.js';
export {
  TaxDocumentTypeWithLiterals,
  SourceTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './payments-tax-documents-v1-tax-document-tax-documents.universal.js';
